import React from 'react';
import { useLocation } from 'react-router-dom';

import { getRouteByFirstSegmentPathname } from '@plugins/router/router';

export const Loader = (): JSX.Element => {
  const { pathname } = useLocation();

  const { skeleton } = getRouteByFirstSegmentPathname(pathname) || {};

  return <>{skeleton || <></>}</>;
};
